import { render, staticRenderFns } from "./GoodsAdd.vue?vue&type=template&id=4cdfc33a&scoped=true"
import script from "./GoodsAdd.vue?vue&type=script&lang=js"
export * from "./GoodsAdd.vue?vue&type=script&lang=js"
import style0 from "./GoodsAdd.vue?vue&type=style&index=0&id=4cdfc33a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdfc33a",
  null
  
)

export default component.exports